import axios from 'axios'

export async function postJSON(url: string, data: any): Promise<any> {
    return await axios.post(url, data).then((r) => r.data)
}

export async function post(url: string, data:any = {}): Promise<any> {
    return await axios.post(url, data)
}